import React from "react";
import Button from "../../../../../../components/ui/Button";
import SwitchComponent from "../../../../../../components/ui/Switch/SwitchComponent";
import {selectActiveTool} from "../config/configSlice";
import {useDispatch, useSelector} from "react-redux";
import {areaActions, selectActiveAreaId, selectAreas} from "../area/areaSlice";
import {topViewWallAreaActions, selectActiveTopViewWallAreaId, selectTopViewWallAreas} from "../topViewWallArea/topViewWallAreaSlice";
import {countActions, selectActiveCountGroupId, selectPlaceMultiplesEnabled} from "../count/countSlice";
import {canCloseArea, canCloseDeduction, canFinishLength} from "../../utils";
import {lengthActions, selectActiveLengthId, selectAddDropModeId, selectLengths} from "../length/lengthSlice";
import {useTranslation} from "react-i18next";
import {EditorTool} from "../../models/enums";

export function EditorHeaderFinishShapePanel() {

	const {t} = useTranslation();
	const dispatch = useDispatch();
	const activeTool = useSelector(selectActiveTool);
	const activeAreaId = useSelector(selectActiveAreaId);
	const activeLengthId = useSelector(selectActiveLengthId);
	const activeCountGroupId = useSelector(selectActiveCountGroupId);
	const placeMultiplesEnabled = useSelector(selectPlaceMultiplesEnabled);
	const addDropModeId = useSelector(selectAddDropModeId);
	const isInAddDropMode = Boolean(addDropModeId);
	const lengths = useSelector(selectLengths);
	const activeLength = lengths.find(length => length.id === activeLengthId);
	const areas = useSelector(selectAreas);
	const activeArea = areas.find(area => area.id === activeAreaId);
	const activeDeduction = activeArea?.deductions.find(deduction => deduction.id === activeArea.activeDeductionId)

	const topViewWallAreaId = useSelector(selectActiveTopViewWallAreaId);
	const topViewWallAreas = useSelector(selectTopViewWallAreas);
	const activeTopViewWallArea = topViewWallAreas.find(m => m.id === topViewWallAreaId);
	const activeWallSegment = activeTopViewWallArea?.wallSegments.find(s => s.id === activeTopViewWallArea.activeSegmentId);
	const canFinishWall = Boolean(activeWallSegment && !activeWallSegment.closed && activeWallSegment.lines.length >= 1);
	const canCloseWall = Boolean(activeWallSegment && !activeWallSegment.closed && activeWallSegment.lines.length >= 2);

	const canFinishLine = Boolean(
		activeLength && canFinishLength(activeLength)
	)
	const canCloseAreaMeasurement = Boolean(
		activeArea && canCloseArea(activeArea)
	)

	const canCloseAreaDeduction = Boolean(
		activeDeduction && canCloseDeduction(activeDeduction)
	)

	function handleFinishLine() {
		dispatch(lengthActions.disableLinePreview())
	}

	function handleExitAddDropMode() {
		dispatch(lengthActions.clearAddDropMode())
	}

	function handleCloseArea() {
		activeArea && dispatch(areaActions.closeArea({area: activeArea}));
	}

	function handleCloseDeduction() {
		activeDeduction && activeArea && activeAreaId && activeArea.activeDeductionId &&
		dispatch(areaActions.closeDeduction({deductionId: activeArea.activeDeductionId, areaId: activeAreaId}))
	}

	if (isInAddDropMode) {
		return <Button onClick={handleExitAddDropMode} label={t("editor.length.exitAddDropMode")} variant={"primary"}/>
	}

	function handleFinishWall() {
		dispatch(topViewWallAreaActions.finishSegment());
	}

	function handleCloseWall() {
		dispatch(topViewWallAreaActions.closeWall());
	}

	if (activeTool === EditorTool.LENGTH && canFinishLine) {
		return <Button onClick={handleFinishLine} label={t("editor.length.finishLine")} variant={"primary"}/>
	}

	if ((activeTool === EditorTool.AREA || activeTool === EditorTool.VOLUME) && canCloseAreaMeasurement) {
		return <Button onClick={handleCloseArea} label={t("editor.area.closeArea")} variant={"primary"}/>
	}

	if ((activeTool === EditorTool.AREA || activeTool === EditorTool.VOLUME) && canCloseAreaDeduction) {
		return <Button onClick={handleCloseDeduction} label={t("editor.area.closeArea")} variant={"primary"}/>
	}

	if (activeTool === EditorTool.COUNT && activeCountGroupId) {
		return (
			<div className="editor-header_count-toggle">
				<span className="editor-header_count-toggle-label">{t("editor.count.placeMultiples")}</span>
				<SwitchComponent
					checked={placeMultiplesEnabled}
					onSwitch={() => dispatch(countActions.togglePlaceMultiples())}
				/>
			</div>
		);
	}

	if (activeTool === EditorTool.TOP_VIEW_WALL_AREA && canFinishWall) {
		return (
			<>
				<Button onClick={handleFinishWall} label={t("editor.topViewWallArea.finishWall")} variant={"primary"}/>
				{canCloseWall && <Button onClick={handleCloseWall} label={t("editor.topViewWallArea.closeWall")} variant={"secondary"}/>}
			</>
		);
	}

	return null;
}